const microscopeConfig = {
  appName: import.meta.env.REACT_APP_MICROSCOPE_APP_NAME || 'typehero',
  environment: import.meta.env.MODE || 'development',
};

export default microscopeConfig;
